var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"notes",fn:function(){return [_vm._v(" The datapoints for 2022 and 2023 are considered provisional due to the time lag in filing applications in the PATSTAT database. Only the countries having more 30 clean energy patents over the time period in the database can be selected on this page. For data on all countries you can download from the full data set at the top of the page. ")]},proxy:true}])},[_c('DataGetter',{attrs:{"url":_vm.apiRoute,"params":{
      countryISO: _vm.countryISO,
      indicator: 'Total',
      topic: 'Patents',
      techSector: ['Fossil fuel patents', 'Clean energy patents'],
      startYear: 2000,
      allYears: true,
    },"lazy":""},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{key:`${_vm.countryISO}patentbyyearslicer`,attrs:{"data":data,"x-axis-dimension":"year","y-axis-dimension":"techSector","value-dimension":"value","data-formatter":_vm.scaleToBase},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"options":{
          ..._vm.chartOptions,
          series: slicedData.map((series) =>
            series.name === 'Share of clean energy patents'
              ? {
                  ...series,
                  type: 'line',
                  yAxis: 1,
                  tooltip: { valueSuffix: '%', valueDecimals: 0 },
                }
              : series
          ),
        }}})]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }